import { FC, ReactNode } from 'react';
import { classNames } from 'primereact/utils';
import { Layout, LoadingSpinner } from '@repo/atomic-components';
import { Header } from './Header';
import { useAppSelector, selectShowDateBar } from '@/store';

interface TimelineChronologyTemplateProps {
  isDataLoading: boolean;
  actionsPanel: ReactNode;
  contentLeftColumn: ReactNode;
  contentMainColumn: ReactNode;
  footer: ReactNode;
}

export const TimelineChronologyTemplate: FC<TimelineChronologyTemplateProps> = ({
  isDataLoading,
  actionsPanel,
  contentLeftColumn,
  contentMainColumn,
  footer,
}) => {
  const showDateBar = useAppSelector(selectShowDateBar);

  return (
    <Layout>
      <div
        className={classNames('grid h-full w-full grid-cols-[1fr]', {
          'grid-rows-[48px_minmax(48px,auto)_1fr]': isDataLoading,
          'grid-rows-[48px_minmax(48px,auto)_1fr_auto]': !isDataLoading,
        })}
      >
        <div className="col-span-full">
          <Header />
        </div>

        <div className="col-span-full">{actionsPanel}</div>

        {isDataLoading ? (
          <div className="col-span-full">
            <LoadingSpinner />
          </div>
        ) : (
          <>
            <div className="col-span-full flex">
              {showDateBar && (
                <div className="bg-fletchers-gray-25 w-[150px] shrink-0 pt-4 pl-[12px]">{contentLeftColumn}</div>
              )}
              <div className={classNames('bg-fletchers-gray-25', showDateBar ? 'w-full' : 'w-full pl-6')}>
                {contentMainColumn}
              </div>
            </div>
            <div className="col-span-full">{footer}</div>
          </>
        )}
      </div>
    </Layout>
  );
};
